import { useEffect, useState } from 'react'
import bannerBg from '@/assets/images/rever-store/header.png'
import UpcomingFeatures from '@/ui/components/rever-store/upcoming-features/upcoming-features'
import ComparisonTable from '@/ui/components/rever-store/comparison-table'
import Plans from '@/ui/components/rever-store/plans'
import MainFeatures from '@/ui/components/rever-store/main-features/main-features'
import { default as OtherSuggestions } from '@/ui/components/rever-store/suggestions/suggestions'
import { useInvoicingInfo } from '@/hooks'

export function ReverStore() {
  const { invoicingData } = useInvoicingInfo()
  const plans = ['Smart', 'Premium', 'Professional']
  const invoicingPlan = invoicingData?.selected_plan

  useEffect(() => {
    if (invoicingPlan) {
      setSelectedPlan(plans.indexOf(invoicingPlan))
    }
  }, [invoicingPlan])

  const [selectedPlan, setSelectedPlan] = useState<number | undefined>(
    invoicingPlan ? plans.indexOf(invoicingPlan) : undefined
  )

  const selectPlan = (index: number) => {
    if (selectedPlan === index) {
      setSelectedPlan(undefined)
    } else {
      setSelectedPlan(index)
    }
  }

  return (
    <div className="[&::-webkit-scrollbar:hidden] flex h-full flex-col items-center overflow-y-scroll p-8">
      <div className="w-full max-w-[1000px]">
        <div className="relative w-full" style={{ color: 'rgb(0, 13, 31)' }}>
          <div className="group relative h-80 overflow-hidden rounded-xl p-3">
            <div className="relative z-10">
              <p className="font-logo mb-2 mt-4 flex px-4 text-5xl uppercase text-white">
                Everyday superpowers. <br />
                Built right in.
              </p>
              <p className="flex max-w-[500px] px-4 text-lg font-light text-white">
                Easy to use. Easy to love. The best way to prepare your
                eCommerce to grow: take a look at what&apos;s new, right now.
              </p>
            </div>
            <div
              className="absolute inset-0 z-0 bg-cover bg-center bg-no-repeat transition-all duration-1000 group-hover:scale-110"
              style={{
                backgroundImage: `url('${bannerBg}')`
              }}
            />
          </div>

          <h3 className="font-logo mb-4 mt-16 text-3xl font-bold text-gray-800">
            FEATURED PRODUCTS
          </h3>
          <MainFeatures />

          <h3 className="font-logo mb-4 mt-12 text-3xl font-bold text-gray-800">
            UP-COMING FEATURES
          </h3>
          <UpcomingFeatures />

          <OtherSuggestions />

          <h3 className="mb-1 mt-32 flex items-center justify-center text-center">
            <span className="font-logo text-6xl ">
              CHOOSE YOUR PERFECT PLAN
            </span>
          </h3>
          <p className="mb-10 mt-4 text-center text-xl font-light">
            The best way to prepare your eCommerce to win.
          </p>
          <Plans selectedPlan={selectedPlan} selectPlan={selectPlan} />

          <h3 className="font-logo my-10 text-center text-3xl font-bold text-gray-800">
            COMPARE PLANS WITH EASE
          </h3>
          <ComparisonTable
            selectedPlan={selectedPlan}
            selectPlan={selectPlan}
          />
        </div>
      </div>
    </div>
  )
}

export default ReverStore
